










import { Component, Vue, Watch } from "vue-property-decorator";
import { MapStoreModule } from "@/store/modules/mapStore";
import { formatSize } from "@/utils/helpers.ts";

@Component
export default class ZipcodeInput extends Vue {
  private zip = "";
  private debouncedzipVerify: any;

  get isInput() {
    return this.zip.length > 0;
  }

  get existStores(): boolean {
    return MapStoreModule.isActiveStatus;
  }

  protected created(): void {
    this.debouncedzipVerify = this.debounce(this.zipVerify, 1300);
  }

  @Watch("zip")
  onZip() {
    this.debouncedzipVerify();
  }

  private zipVerify() {
    if (this.zip.match(/(^\d{5})(-\d{4})?$/)) {
      this.sendRequests();
      return;
    }
    if (this.zip.length == 0) {
      MapStoreModule.tooggleActive(false);
      MapStoreModule.tooggleError(false);
      MapStoreModule.wasRequest(false);
      return;
    }
    MapStoreModule.tooggleActive(false);
    MapStoreModule.wasRequest(false);
    MapStoreModule.tooggleError(true);
  }

  private sendRequests() {
    MapStoreModule.dataRequest(this.zip);
  }

  private debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }
  private totalOfProjects() {
    return formatSize("" + Object.keys(MapStoreModule.stores).length);
  }
}
